import { Close, MailOutline, PhoneOutlined, QuizOutlined } from '@mui/icons-material'
import { Box, Modal } from '@mui/material'
import { useStyles } from './styles'

type THelpModal = {
  openModal: boolean
  setOpenModal: () => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  overflow: 'hidden',
}

const HelpModal = ({ openModal, setOpenModal }: THelpModal) => {
  const classes = useStyles()

  return (
    <Modal
      open={openModal}
      onClose={setOpenModal}
    >
      <Box sx={style}>
        <Box className={classes.titleAndDescriptionContainer}>
          <Box className={classes.titleAndCloseButton}>
            <span className={classes.title}>Precisa de ajuda?</span>
            <Close
              className={classes.closeBtn}
              onClick={setOpenModal}
            />
          </Box>
          <span className={classes.subTitle}>
            Consulte nossa Central de Ajuda ou entre em contato com o nosso suporte.
          </span>
        </Box>

        <Box className={classes.infosContainer}>
          <Box className={classes.wppContainer}>
            <QuizOutlined />
            <a
              href='https://conducco.github.io/central-de-ajuda/'
              target='_blank'
              rel='noopener noreferrer'
              className={classes.descriptions}
            >
              Central de Ajuda
            </a>
          </Box>
          <Box className={classes.wppContainer}>
            <PhoneOutlined />
            <a
              href='tel:+5511988384280'
              className={classes.descriptions}
            >
              +55 (11) 98838-4280
            </a>
          </Box>
          <Box className={classes.mailContainer}>
            <MailOutline />
            <a
              href='mailto:suporte@conducco.com'
              className={classes.descriptions}
            >
              suporte@conducco.com
            </a>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default HelpModal
